// Listing and profile actions share these links so a conversation opens with the
// intended recipient and listing context. Seeded listings without an owner cannot
// start a real conversation, so callers receive null and omit that action.

/** Build the Messages compose link used by marketplace actions. */
export function messagesHref(
  toUserId: number | null | undefined,
  opts: { type?: string; id?: string; name?: string; intent?: string; subject?: string; bidId?: string } = {},
): string | null {
  if (!toUserId) return null;
  const sp = new URLSearchParams();
  sp.set("to", String(toUserId));
  if (opts.type) sp.set("type", opts.type);
  if (opts.id) sp.set("id", opts.id);
  if (opts.name) sp.set("name", opts.name);
  if (opts.intent) sp.set("intent", opts.intent);
  if (opts.subject) sp.set("subject", opts.subject);
  if (opts.bidId) sp.set("bidId", opts.bidId);
  return `/messages?${sp.toString()}`;
}

/** Copy the current page URL to the clipboard; returns true on success. */
export async function copyShareLink(): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(window.location.href);
    return true;
  } catch {
    return false;
  }
}
